// Image imports
import bibasFamilyPng from '../../../images/bibas-family.png';

export const bibasFamilyMemorial = {
  id: 11,
  name: 'The Bibas Family',
  category: 'families',
  images: {
    family: bibasFamilyPng
  },
  info: `

# The Bibas Family

"My light is still there, and as long as they are there, everything here is dark." - Yarden Bibas

![The Bibas Family](${bibasFamilyPng})
*Yarden and Shiri Bibas with their sons Ariel and Kfir*

## A Family Torn Apart

Shiri Bibas was a devoted mother whose life revolved around her beautiful boys. Her smile would light up any room, and her dedication to her family was unwavering. On that terrible morning of October 7th, 2023, she did what any mother would do - she clutched her children close, trying desperately to protect them from the unimaginable horror unfolding around them.

Ariel, with his bright eyes and fiery red hair, was just 4 years old - a curious, playful child who adored his little brother. And baby Kfir, not even a year old at just 9 months, had his whole life ahead of him. He was the youngest hostage taken that day, a fact that broke hearts around the world.

## A Community United in Orange

The vibrant orange that came to symbolize the Bibas boys, inspired by their distinctive red hair, became a powerful emblem of hope and remembrance. Across Israel and beyond, people wore orange, held orange balloons, and created orange artworks to keep the memory of these precious children alive.

Yarden, their father, held onto hope through 484 days of captivity, not knowing the fate of his beloved family. When he was finally released on February 1st, 2025, he discovered the devastating truth - his family would never come home alive.

## A Nation in Mourning

On February 26th, 2025, thousands lined the streets of Israel as the funeral procession made its way to Tzohar cemetery. Blue and white Israeli flags fluttered alongside orange balloons, a testament to how deeply the Bibas family's story had touched the nation's heart.

Dana Silberman-Sitton, Shiri's sister, reached out from the funeral car to clasp the hands of well-wishers - a moment of human connection amid unfathomable grief.

Ofri Bibas, Yarden's sister, spoke words that resonated with a broken nation:

> "Our disaster as a people and as a family should not have happened, and it must not, must not happen again. They could have saved you and preferred revenge."

## Remembering Their Light

Yarden's words after his release speak to the depth of his loss and the empty space where his family should be:

> "My light is still there, and as long as they are there, everything here is dark. You helped bring me home—now help me bring back the light to my life."

Though Shiri, Ariel, and Kfir are gone, their light continues to shine in the memories of those who loved them and the countless hearts they touched around the world. Their story became intertwined with Israel's national consciousness, a symbol of innocence lost and a reminder of the human cost of violence.

May the memory of Shiri, Ariel, and Kfir Bibas be a blessing. May their light continue to shine in our hearts.

*Until we meet again. We love you always and miss you forever.*

`
};